// extracted by mini-css-extract-plugin
export default {"screen":"MaintenanceScreen_screen__TzTx0","title":"MaintenanceScreen_title__kzxQN","subtitle":"MaintenanceScreen_subtitle__+L3Dd"};